export default {"src":"/_next/static/media/mail.aef30d91.svg","height":16,"width":20};